import React from 'react';
import {UserProfileData} from "../../services/Types";

const UserDetailsPanel: React.FC<{ userDetails: UserProfileData }> = ({ userDetails }) => {
  return (
    <div>
      <h3>User Details</h3>
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px'}}>
        <div>
          <h4>Basic Info</h4>
          <p>Happy to be emailed: {userDetails.emailAllow ? 'Yes' : 'No'}</p>
          <p>Gender: {userDetails.gender}</p>
          <p>Age Group: { userDetails.ageGroup !== 'other' ? userDetails.ageGroup : (userDetails.ageGroupOther || '-') }</p>
          <p>Ethnic Group: { (userDetails.ethnicGroups && userDetails.ethnicGroups.indexOf('other') < 0) ? userDetails.ethnicGroups : userDetails.ethnicGroups?.map(group => group.replace('other', (userDetails.ethnicGroupOther || '-'))) }</p>
          <p>How Did You Find Out: {userDetails.howDidYouFindOut !== 'other' ? userDetails.howDidYouFindOut : (userDetails.howDidYouFindOutOther || '-')}</p>
        </div>
        <div>
          <h4>Extra info</h4>
          <p>Contact Permission: {userDetails.contactPermission ? 'Yes' : 'No'}</p>
          <p>Registration Source: {userDetails.registrationSource}</p>
          <p>User Agent: {userDetails.userAgent}</p>
          <p>Habits ID: {userDetails.habitsId || '-'}</p>
        </div>
        <div>
          <h4>Deprecated fields</h4>
          <p>Mobile: {userDetails.mobile || '-'}</p>
          <p>Happy to receive txts: {userDetails.smsAllow ? 'Yes' : 'No'}</p>
          <p>Where to Live: {userDetails.location|| '-'}</p>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsPanel;
